import { render, staticRenderFns } from "./Packages.vue?vue&type=template&id=37cc7286&scoped=true&"
import script from "./Packages.vue?vue&type=script&lang=ts&"
export * from "./Packages.vue?vue&type=script&lang=ts&"
import style0 from "./Packages.vue?vue&type=style&index=0&id=37cc7286&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37cc7286",
  null
  
)

export default component.exports